import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { LoyaltyProgram } from 'src/app/assabil-sales/models/entities/loyalty-program';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';



@Component({
    selector: 'loyalty-program-lov',
    templateUrl: './loyalty-program-lov.component.html',
    styleUrls: ['./loyalty-program-lov.component.scss']
})

export class LoyaltyProgramLov extends GenericLovComponent{
  
  // Filter fields
  // -------------------------------------------------------------------------------------
  code: string;
  name: string;
  // -------------------------------------------------------------------------------------
      
  // -------------------------------------------------------------------------------------
  loyaltyPrograms: LoyaltyProgram[] = [];
  // -------------------------------------------------------------------------------------
  

    columns = [
        { prop: 'loyaltyProgramCode',  name: 'Code'},
        { prop: 'name',              name: 'Name' }
    ]

    constructor(
        public dialogRef            : MatDialogRef<LoyaltyProgram>,
        protected loyaltyService    : LoyaltyService,
        protected toastr            : ToastrService,
        protected router            : Router,
        protected location : Location) {
            super();
    }
      
    loadData() {
        this.loyaltyService.loyaltyProgramsGet(this.code, this.name).then(result => {
            this.loyaltyPrograms = result;
        })
    }

    //----------------------------------------------------------------------------------------------------------------
    closeModal(loyaltyProgram : LoyaltyProgram){
        this.dialogRef.close(loyaltyProgram);
    }
     //----------------------------------------------------------------------------------------------------------------
    

}
